module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-39fa961fcf53e2e0a29952018156a6ee.svg";